import { useEffect, useState } from "react";

const usePrograms = (lang, defaultValue) => {
    const [allPrograms, setAllPrograms] = useState([]);
    const [filteredPrograms, setFilteredPrograms] = useState([]);
    const [categoryOneOptions, setCategoryOneOptions] = useState([]);
    const [categoryTwoOptions, setCategoryTwoOptions] = useState([]);
    const [selectedCategoryOne, setSelectedCategoryOne] = useState(defaultValue);
    const [selectedCategoryTwo, setSelectedCategoryTwo] = useState(defaultValue);

    useEffect(() => {
        const data = window.iflPrograms || [];
        const sorted = [...data].sort((a, b) =>
            (a.title || '').localeCompare(b.title || '', 'sv')
        );
        setAllPrograms(sorted);
        setFilteredPrograms(sorted);
        setCategoryOneOptions(
            uniqueValues(data, "categoryOne").sort((a, b) => a.localeCompare(b, 'sv'))
        );
        setCategoryTwoOptions(
            uniqueValues(data, "categoryTwo").sort((a, b) => a.localeCompare(b, 'sv'))
        );
    }, []);

    useEffect(() => {
        if (selectedCategoryOne === "" || selectedCategoryOne === defaultValue) {
            setSelectedCategoryTwo(defaultValue);
        }
    }, [selectedCategoryOne, defaultValue]);


    useEffect(() => {
        if (selectedCategoryTwo === "" || selectedCategoryTwo === defaultValue) {
            setSelectedCategoryOne(defaultValue);
        }
    }, [selectedCategoryTwo, defaultValue]);

    useEffect(() => {
        const filtered = allPrograms.filter((program) => {
            const matchesCategoryOne =
                selectedCategoryOne === "" || selectedCategoryOne === defaultValue ||
                (Array.isArray(program.categoryOne) &&
                    program.categoryOne.includes(selectedCategoryOne));

            const matchesCategoryTwo =
                selectedCategoryTwo === "" || selectedCategoryTwo === defaultValue ||
                (Array.isArray(program.categoryTwo) &&
                    program.categoryTwo.includes(selectedCategoryTwo));

            return matchesCategoryOne && matchesCategoryTwo;
        });

        setFilteredPrograms(filtered);

        const categoryOneFiltered = allPrograms.filter((program) => {
            return (
                selectedCategoryTwo === "" || selectedCategoryTwo === defaultValue ||
                (Array.isArray(program.categoryTwo) &&
                    program.categoryTwo.includes(selectedCategoryTwo))
            );
        });
        setCategoryOneOptions(
            uniqueValues(categoryOneFiltered, "categoryOne").sort((a, b) => a.localeCompare(b, 'sv'))
        );

        const categoryTwoFiltered = allPrograms.filter((program) => {
            return (
                selectedCategoryOne === "" || selectedCategoryOne === defaultValue ||
                (Array.isArray(program.categoryOne) &&
                    program.categoryOne.includes(selectedCategoryOne))
            );
        });
        setCategoryTwoOptions(
            uniqueValues(categoryTwoFiltered, "categoryTwo").sort((a, b) => a.localeCompare(b, 'sv'))
        );
    }, [allPrograms, selectedCategoryOne, selectedCategoryTwo, defaultValue]);

    function uniqueValues(data, key) {
        const allValues = data.flatMap((item) =>
            Array.isArray(item[key]) ? item[key] : item[key] ? [item[key]] : []
        );
        return [...new Set(allValues)].filter(Boolean);
    }

    return {
        filteredPrograms,
        categoryOneOptions,
        categoryTwoOptions,
        selectedCategoryOne,
        selectedCategoryTwo,
        setSelectedCategoryOne,
        setSelectedCategoryTwo,
        defaultValue, 
    };
};

export default usePrograms;
